<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-data-table
              :headers="headers"
              :items="dataItems"
              :loading="loading"
              :search="search"
              class="elevation-1"
              item-key="_id"
          >
            <template v-slot:top>
              <v-toolbar
                  flat
              >
                <v-toolbar-title>
                  Products
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    hide-details
                    label="Search Product"
                    single-line
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog
                    v-model="dialog"
                    max-width="500px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-model="addProduct"
                        v-bind="attrs"
                        v-on="on"
                        class="mb-2"
                        color="primary"
                        dark
                        @click="addProduct = true"
                    >
                      New Product
                    </v-btn>
                  </template>

                  <!--
                    Alerts & Loaders
                  -->
                  <Loader :loading="loadingCreateUpdateDelete"/>
                  <!--<Alerts :aType.sync="response"/>-->

                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" md="4" sm="6">
                            <div>
                              <v-text-field
                                  v-model="editedItem.product_name"
                                  label="Name"
                                  @blur="!$v.editedItem.product_name.$touch()"
                              ></v-text-field>
                              <p v-if="$v.editedItem.product_name.$model === '' && !$v.editedItem.product_name.required"
                                 style="color: red;">Please insert the product name.</p>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4" sm="6">
                            <div>
                              <v-autocomplete
                                  v-model="editedItem.product_category"
                                  :items="categories"
                                  auto-select-first
                                  clearable
                                  label="Category"
                                  @blur="!$v.editedItem.product_category.$touch()"

                              ></v-autocomplete>
                              <p v-if="$v.editedItem.product_category.$model === '' && !$v.editedItem.product_category.required"
                                 style="color: red;">Please select a category.</p>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4" sm="6">
                            <div>
                              <v-text-field
                                  v-model="editedItem.product_price"
                                  label="Price (€)"
                                  @blur="!$v.editedItem.product_price.$touch()"
                              ></v-text-field>
                              <p v-if="!$v.editedItem.product_price.check_price" style="color: red;">Please provide a
                                numeric
                                value.</p>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                          :disabled="$v.$invalid"
                          color="blue darken-1"
                          text
                          @click="save"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="550px">
                  <v-card>
                    <v-card-title class="headline">Are you sure you want to remove this product?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                  <Loader :loading="loadingCreateUpdateDelete"/>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                  class="mr-2"
                  small
                  @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                  small
                  @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import {
  manager_create_product, manager_delete_product,
  manager_get_all_products,
  manager_get_categories,
  manager_update_product
} from "../../modules/nite_api";
import {required, helpers} from 'vuelidate/lib/validators';
import Loader from "../shared/Loader"
import VueNotifications from "vue-notifications";

//Check if the price is valid
const check_price = helpers.regex('numeric', /([0-9]*[.])?[0-9]+/);

export default {
  components: {
    Loader
  },
  data: () => ({
    response: null,
    loadingCreateUpdateDelete: false,
    loading: false,

    menuDate: false,
    dialog: false,
    dialogDelete: false,
    addProduct: false,
    search: '',
    categories: [],
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'product_name',
      },
      {text: 'Category', value: 'product_category', sortable: true},
      {text: 'Price (€)', value: 'product_price', sortable: true},
      {text: 'Actions', value: 'actions', sortable: false},
    ],
    dataItems: [],
    editedItem: {
      product_name: '',
      product_category: '',
      product_price: 0.0,
      product_id: ''
    },
    defaultItem: {
      product_name: '',
      product_category: '',
      product_price: 0.0,
      product_id: ''
    },
  }),
  validations: {
    editedItem: {
      product_name: {
        required
      },
      product_category: {
        required
      },
      product_price: {
        check_price,
        required
      }
    }
  },
  computed: {
    formTitle() {
      return this.addProduct === true ? 'New Product' : 'Edit Product'
    },

  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },

  },

  created() {
    this.getDataFromApi()
  },

  methods: {
    async getDataFromApi() {
      this.loading = true
      try {
        let [u1, u2] = await Promise.all([
          manager_get_all_products(),
          manager_get_categories()
        ]);
        // Success
        this.dataItems = u1.data;
        this.categories = u2.data.map((cat) => cat.name);

      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      } finally {
        this.loading = false;
        switch (this.response) {
          case 200:
            break;

          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }

      }

    },


    editItem(item) {
      this.editedItem.product_name = item.product_name
      this.editedItem.product_category = item.product_category
      this.editedItem.product_price = item.product_price
      this.editedItem.product_id = item._id
      this.dialog = true
    },

    deleteItem(item) {
      this.editedItem.product_id = item._id
      this.dialogDelete = true
    },

    async deleteItemConfirm() {
      this.loadingCreateUpdateDelete = true;
      try {

        const response = await manager_delete_product(this.editedItem.product_id);

        // Success
        console.log(response);
        this.response = response.status;

      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      } finally {
        this.loadingCreateUpdateDelete = false;
        switch (this.response) {
          case 200:
            this.showSuccessMsg({title: 'Success', message: 'Product deleted successfully!'});
            break;

          case 401:
            this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
            break;
          case 404:
            this.showErrorMsg({title: 'Oops', message: 'The product doesn\'t exist! Please try again!'});
            break;

          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }

      }

      this.closeDelete()
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      })
      this.addProduct = false
      this.getDataFromApi()

    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      })
      this.getDataFromApi()
    },

    async save() {
      let request_data = {

        "product_name": this.editedItem.product_name,
        "product_category": this.editedItem.product_category,
        "product_price": this.editedItem.product_price,
      }
      this.loadingCreateUpdateDelete = true;
      if (this.addProduct) {
        try {

          const response = await manager_create_product(request_data);

          // Success
          console.log(response);
          this.response = response.status;

        } catch (error) {
          // Error
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            console.log(error.response.data);
            console.log(error.response.status);
            this.response = error.response.status;

            console.log(error.response.headers);
          } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
          } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        } finally {
          this.loadingCreateUpdateDelete = false;
          switch (this.response) {
            case 200:
              this.showSuccessMsg({title: 'Success', message: 'Product added successfully!'});
              break;

            case 400:
              this.showErrorMsg({
                title: 'Oops',
                message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
              });
              break;
            case 401:
              this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
              break;
            case 500:
              this.showErrorMsg({
                title: 'Error',
                message: 'Something went wrong with the request. Please try again later!'
              });
              break;
            default:
              break;
          }

        }

      } else {
        try {


          const response = await manager_update_product(this.editedItem.product_id, request_data);

          // Success
          console.log(response);
          this.response = response.status;
        } catch (error) {
          // Error
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            console.log(error.response.data);
            console.log(error.response.status);
            this.response = error.response.status;

            console.log(error.response.headers);
          } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
          } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        } finally {
          this.loadingCreateUpdateDelete = false;
          switch (this.response) {
            case 200:
              this.showSuccessMsg({title: 'Success', message: 'Product updated successfully!'});
              break;
            case 304:
              this.showWarnMsg({title: 'Oops', message: 'You didn\'t update nothing!'});
              break;
            case 400:
              this.showErrorMsg({
                title: 'Oops',
                message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
              });
              break;
            case 401:
              this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
              break;
            case 500:
              this.showErrorMsg({
                title: 'Error',
                message: 'Something went wrong with the request. Please try again later!'
              });
              break;
            default:
              break;
          }

        }

      }

      this.close()
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Hello there',
      message: 'That\'s the success!'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Hey you',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Wow, man',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'Wow-wow',
      message: 'That\'s the error'
    }
  }
}
</script>


